import { render, staticRenderFns } from "./AppListEvent.vue?vue&type=template&id=12f8e90f&"
import script from "./AppListEvent.vue?vue&type=script&lang=js&"
export * from "./AppListEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports